export default __webpack_public_path__ + "static/media/photo.627cad2b.jpeg";